module.exports = __webpack_public_path__ + "img/1584223802.05e4acf1.jpg";